import { Injectable } from '@angular/core';
import { ProductConfiguration } from '../product-configuration';

@Injectable()
export class ProductConfigurationSimple extends ProductConfiguration {
    /**
     * Configuration type
     */
    readonly type = 'simple';
}
